// extracted by mini-css-extract-plugin
export default {"slider":"ImageSlider2_slider__PaKDb","slideTrack":"ImageSlider2_slideTrack__bJ6hr","scroll":"ImageSlider2_scroll__KVcrF","slide":"ImageSlider2_slide__1e92R"};